<template>
  <v-container fluid>
    <v-row>
      <v-col>
        <user-authorization-documents-list
            ref="authorizationDocumentList"
            :authorization-documents="authorizationDocuments"
            :total-count="totalCount"
            :edited="getAuthorizationDocumentsAdmin"
            :loading="isLoading"
            :user-id="userId"
            :create-method="createUserAuthorizationDocument"
            :document-type="documentType"
            :document-group="documentGroup"
            can-create
            can-edite
            enable-filters />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>

  import UserAuthorizationDocumentsList from '@/components/reused/authorizationDocuments/UserAuthorizationDocumentsList.vue'
  import { AUTHORIZATION_DOCUMENT_TYPES, IDENTITY_DOCUMENT_GROUPS } from '@/constants/business'
  import { mapActions, mapState } from 'vuex'
  import { USER_MANAGEMENT } from '@/constants/store.js'

  export default {
    components: {
      UserAuthorizationDocumentsList
    },
    props: {
      userId: {
        type: String,
        required: true
      },
      userParticipantType: {
        type: String,
        required: true
      }
    },
    data () {
      return {
        isLoading: false
      }
    },
    computed: {
      ...mapState(USER_MANAGEMENT.NAMESPACE, {
        authorizationDocumentsInfo: state => (state[USER_MANAGEMENT.STATE.AUTHORIZATION_DOCUMENTS] || {})
      }),
      totalCount () {
        return this.authorizationDocumentsInfo.totalCount || 0
      },
      authorizationDocuments () {
        return this.authorizationDocumentsInfo.items || []
      },
      headers () {
        return [
          { text: this.$t('Документ'), sortable: false, value: 'file.fileName' },
          { text: this.$t('Дата начала действия'), sortable: false, value: 'dateBegin' },
          { text: this.$t('Дата завершения действия'), sortable: false, value: 'dateEnd' },
          { text: this.$t('ФИО доверенного лица'), sortable: false, value: 'contactPerson' },
          { text: this.$t('Статус'), sortable: false, value: 'status' },
          { text: this.$t('Действия'), sortable: false, value: 'file.fileId' }
        ]
      },
      documentType () {
        return AUTHORIZATION_DOCUMENT_TYPES.USER_AUTHORIZATION_DOCUMENT
      },
      documentGroup () {
        return IDENTITY_DOCUMENT_GROUPS.ORGANIZATION_AGENT_DOCUMENTS
      }
    },
    created () {
      this.clearStore()
    },
    beforeDestroy () {
      this.clearStore()
    },
    methods: {
      ...mapActions(USER_MANAGEMENT.NAMESPACE, {
        getAuthorizationDocumentsAdminAction: USER_MANAGEMENT.ACTIONS.GET_AUTHORIZATION_DOCUMENTS_ADMIN,
        createAuthorizationDocumentAdminAction: USER_MANAGEMENT.ACTIONS.CREATE_AUTHORIZATION_DOCUMENT_ADMIN,
        clearAuthorizationDocumentsAdminAction: USER_MANAGEMENT.ACTIONS.CLEAR_AUTHORIZATION_DOCUMENTS_ADMIN
      }),
      clearStore: async function () {
        await Promise.all(
          [
            this.clearAuthorizationDocumentsAdminAction()
          ])
      },
      getAuthorizationDocumentsAdmin: async function (params) {
        try {
          this.isLoading = true
          await this.getAuthorizationDocumentsAdminAction({
            userId: this.userId,
            params
          })
          this.isLoading = false
        } catch (error) {
          this.isLoading = false
          this.throwIfNotServerError(error)
        }
      },
      createUserAuthorizationDocument: async function (authorizationDocument) {
        try {
          this.isLoading = true

          await this.createAuthorizationDocumentAdminAction({
            userId: this.userId,
            authorizationDocument
          })
          this.isLoading = false
          this.$refs.authorizationDocumentList.getAuthorizationDocumentsList()
        } catch (error) {
          this.isLoading = false
          throw error
        }
      }
    }
  }
</script>
